import { z } from 'zod';
/**
 * Анонсы — модалка поверх интерфейса при входе («появилась десктоп-версия»).
 * Контент и включение задаются в админке; клиент только показывает то,
 * что пришло, и отмечает показ. Пустой/выключенный анонс = ничего не видно.
 */
export const announcementAudienceSchema = z.enum(['ALL', 'RENOVATION', 'FINANCE']);
/** Ссылка кнопки: внутренний путь (/reports) или внешний https. */
const ctaUrlSchema = z
    .string()
    .max(500)
    .refine((value) => value.startsWith('/') || /^https:\/\//.test(value), {
    message: 'Ссылка должна быть внутренним путём (/reports) или https-адресом',
});
// ─── Клиент ──────────────────────────────────────────────────────────────────
/** GET /announcements/active — то, что нужно показать пользователю сейчас. */
export const announcementSchema = z.object({
    key: z.string(),
    title: z.string(),
    body: z.string(),
    emoji: z.string().nullable(),
    imageUrl: z.string().nullable(),
    ctaLabel: z.string().nullable(),
    ctaUrl: z.string().nullable(),
});
/**
 * Ответ ручки: все неувиденные анонсы разом, в порядке показа.
 * Пустой массив — показывать нечего (обычное состояние).
 * Несколько штук клиент листает каруселью.
 */
export const activeAnnouncementsResponseSchema = z.object({
    announcements: z.array(announcementSchema),
});
/** Больше за раз не показываем: карусель на десяток слайдов никто не долистает. */
export const MAX_ACTIVE_ANNOUNCEMENTS = 5;
/**
 * Архив (GET /announcements/all) открывают осознанно, поэтому лимит выше
 * автопоказа — но не бесконечный: это карусель, а не лента.
 */
export const MAX_ARCHIVE_ANNOUNCEMENTS = 20;
/**
 * POST /announcements/:key/seen — отметка о взаимодействии с анонсом.
 *
 * Клиент шлёт её дважды: пустым телом в момент показа (это и есть «увидел»,
 * по нему считается охват) и с `closed`/`cta` при закрытии. Правило «один раз
 * на человека» работает от первой отметки, поэтому анонс не всплывёт заново,
 * даже если вкладку закрыли не читая.
 */
export const announcementSeenRequestSchema = z.object({
    closed: z.boolean().optional(),
    cta: z.boolean().optional(),
});
// ─── Админка ─────────────────────────────────────────────────────────────────
export const createAnnouncementSchema = z.object({
    key: z
        .string()
        .min(1)
        .max(64)
        .regex(/^[a-z0-9_]+$/, 'только латиница, цифры и _'),
    title: z.string().min(1).max(120),
    body: z.string().min(1).max(2000),
    emoji: z.string().max(8).nullable().optional(),
    imageUrl: z.string().max(500).nullable().optional(),
    ctaLabel: z.string().max(40).nullable().optional(),
    ctaUrl: ctaUrlSchema.nullable().optional(),
    audience: announcementAudienceSchema.optional(),
    // По умолчанию выключен: создать анонс заранее и включить отдельным действием.
    enabled: z.boolean().optional(),
    startsAt: z.string().datetime().nullable().optional(),
    endsAt: z.string().datetime().nullable().optional(),
    priority: z.number().int().optional(),
});
export const updateAnnouncementSchema = createAnnouncementSchema.partial().omit({ key: true });
//# sourceMappingURL=announcement.js.map